import posthog from 'posthog-js';
import { PostHogProvider as BasePostHogProvider } from 'posthog-js/react';

import type React from 'react';

import config from '#/config';
import { ClientOnly } from '#/lib/client-only';
import { isClient } from '#/utils/general';

if (isClient()) {
  posthog.init(config.posthog.apiKey, {
    api_host: config.posthog.apiHost,
    autocapture: true,
    capture_pageleave: false,
    capture_pageview: false,
    opt_in_site_apps: true,
    enable_recording_console_log: true,
    enable_heatmaps: true,
    capture_heatmaps: true,
    capture_performance: true,
    mask_all_text: false,
    mask_all_element_attributes: false,
  });
}

export type PostHogProviderProps = React.PropsWithChildren;

export function PostHogProvider({ children }: PostHogProviderProps) {
  return (
    <ClientOnly fallback={children}>
      {() => <BasePostHogProvider client={posthog}>{children}</BasePostHogProvider>}
    </ClientOnly>
  );
}
